module.exports = __webpack_public_path__ + "img/date.00e4cad1.svg";